import React, { FC, useState } from "react";
import { Link, Outlet } from "react-router-dom";
import {
  SidebarListContainer,
  SidebarListItem,
  SidebarListItemWrapper,
  SidebarListItemName,
} from "./sidebarStyle";
import { SIDEBAR_DATA } from "./SidebarData";

interface SidebarListProps {
  extendSidebar?: boolean;
  onClickLink?: React.MouseEventHandler<HTMLElement>;
}

const SidebarList: FC<SidebarListProps> = ({ extendSidebar, onClickLink }) => {
  const [activeItem, setActiveItem] = useState(0);
  return (
    <>
      <SidebarListContainer extendSidebar={extendSidebar}>
        {SIDEBAR_DATA.map((itemData, index) => (
          <SidebarListItem
            key={index}
            onClick={() => setActiveItem(index)}
            className={index === activeItem ? "active" : ""}
          >
            <Link
              className="sidebar-list-link"
              to={itemData.rootUrl}
              onClick={onClickLink}
            >
              <SidebarListItemWrapper>
                <SidebarListItemName>{itemData.name}</SidebarListItemName>
              </SidebarListItemWrapper>
            </Link>
          </SidebarListItem>
        ))}
      </SidebarListContainer>
      <Outlet />
    </>
  );
};

export default SidebarList;
